export enum SubscriptionState {
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
  WAITING_FOR_PEER = 'WAITING_FOR_PEER',
  RESUBSCRIBE = 'RESUBSCRIBE',
  SUBSCRIBING = 'SUBSCRIBING',
  SUBSCRIBED = 'SUBSCRIBED',
  FAILED = 'FAILED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  RECONFIGURING = 'RECONFIGURING',
  UNSUBSCRIBING = 'UNSUBSCRIBING',
}
